__turbopack_context__.v({
  "attribution": "NewsAiSummary-module__8CwAcW__attribution",
  "details": "NewsAiSummary-module__8CwAcW__details",
  "title": "NewsAiSummary-module__8CwAcW__title",
});
